import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KnBrCartPageOptionsComponentModule } from 'src/app/kn-br-draft-order/kn-br-draft-order-list/kn-br-cart-page-options/kn-br-cart-page-options.module';
import { FormErrorsModule } from '@spartacus/storefront';
import { CwtCheckoutInstructionsComponent } from './cwt-checkout-instructions.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        I18nModule,
        FormErrorsModule,
        KnBrCartPageOptionsComponentModule,
        CwtCheckoutInstructionsComponent
    ]
})

export class CwtCheckoutInstructionsModule { }
